
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType = typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType[keyof typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendListResponsePageAllOfThreeContentItemContentTweetsItemMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
